/**
 * The alias a widget's binding is on, for the binding editor (EntityAliasPicker) to open at (B6, 2026-10-19). Pure.
 */
import type { AliasOption } from "./EntityAliasPicker";
import type { DataSource } from "./types";

/**
 * The alias a widget's binding is on: a binding by label (an older port binding, a tag binding) is the alias of that
 * label; a board card's machine binding (byEntity) names the machine by its entity id and is the alias of that machine,
 * or, where the plant model does not hold it, one made of the keys it binds, so the editor opens on the binding and does
 * not go blank.
 */
export function aliasOfSource(aliases: readonly AliasOption[], value: DataSource | undefined): AliasOption | null {
  if (!value) return null;
  if (!value.byEntity) return aliases.find((a) => a.label === value.alias) ?? null;
  const machine = aliases.find((a) => a.entityId === value.alias);
  if (machine) return machine;
  const keys = [...new Set(Object.values(value.slots ?? {}).flat())];
  return { label: value.alias, resolves: "machine", kind: "port", keys, entityId: value.alias };
}

/** Whether an alias is the one a widget's binding is on (see aliasOfSource). */
export function isBoundAlias(value: DataSource | undefined, alias: AliasOption): boolean {
  if (!value) return false;
  return value.byEntity ? alias.entityId !== undefined && alias.entityId === value.alias : value.alias === alias.label;
}
